import React, { FC } from 'react';
import ChangePlanDialogView from './ChangePlanDialogView';
import { useChangePlanDialogController } from '../../../controllers';
import { ChangePlanDialogProps } from '../../../types';

const ChangePlanDialog: FC<ChangePlanDialogProps> = props => {
  const viewModel = useChangePlanDialogController(props);
  return <ChangePlanDialogView {...viewModel} />;
};

export default ChangePlanDialog;
